(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lyn-home-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-lyn-ing-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.lynIngOpen);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    if (event.target.closest('[data-lyn-ing-close]')) {
      event.target.closest('dialog')?.close();
      return;
    }
    // Clic sur le fond (hors du contenu) : fermer.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('lyn-ing__dialog')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyn-home-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lyn-reviews')) {
    customElements.define(
      'lyn-reviews',
      class extends HTMLElement {
        connectedCallback() {
          if (this.hasAttribute('data-slider')) this.initSlider();
          const button = this.querySelector('[data-lyn-more]');
          if (!button) return;
          button.addEventListener('click', () => {
            const extra = [...this.querySelectorAll('[data-lyn-extra]')];
            extra.forEach((card) => card.removeAttribute('hidden'));
            button.closest('.lyn-rev__more').remove();
            extra[0]?.setAttribute('tabindex', '-1');
            extra[0]?.focus({ preventScroll: true });
          });
        }

        initSlider() {
          const track = this.querySelector('[data-lyn-track]');
          if (!track) return;
          const cards = [...track.children];
          const prev = this.querySelector('[data-lyn-prev]');
          const next = this.querySelector('[data-lyn-next]');
          const dots = [...this.querySelectorAll('[data-lyn-dot]')];
          const step = () => (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth);
          const goTo = (i) => track.scrollTo({ left: Math.max(0, Math.min(i, cards.length - 1)) * step() });
          const current = () => Math.round(track.scrollLeft / step());
          const update = () => {
            const max = track.scrollWidth - track.clientWidth - 2;
            if (prev) prev.disabled = track.scrollLeft <= 2;
            if (next) next.disabled = track.scrollLeft >= max;
            const i = track.scrollLeft >= max ? cards.length - 1 : current();
            dots.forEach((d, n) => d.setAttribute('aria-current', n === i ? 'true' : 'false'));
          };
          prev?.addEventListener('click', () => goTo(current() - 1));
          next?.addEventListener('click', () => goTo(current() + 1));
          dots.forEach((d) => d.addEventListener('click', () => goTo(Number(d.dataset.lynDot))));
          track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
          track.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
            if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
          });
          window.addEventListener('resize', update);
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyn-jvip-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lyn-jvip-timer')) {
    customElements.define('lyn-jvip-timer', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.out = this.querySelector('strong') || this;
        if (Number.isNaN(this.end)) return;
        this.tick();
        this.t = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.t); }
      tick() {
        const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        const pad = (n) => String(n).padStart(2, '0');
        const h = Math.floor(left / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
        // Avant le jour J, l'écart dépasse 24 h : on affiche les jours.
        this.out.textContent = h >= 24 ? `${Math.floor(h / 24)}j ${pad(h % 24)}:${pad(m)}:${pad(s)}` : `${pad(h)}:${pad(m)}:${pad(s)}`;
        if (left === 0) { clearInterval(this.t); this.closest('[data-hide-when-done]')?.setAttribute('hidden', ''); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyn-jvip-gate"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lyn-jvip-gate')) {
    customElements.define('lyn-jvip-gate', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="code"]');
        this.error = this.querySelector('.lyn-jvip-gate__error');
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.check(this.input.value); });
        // Lien d'email du type ?code=XXXX : déverrouillage automatique.
        const fromUrl = new URLSearchParams(location.search).get('code');
        if (fromUrl) this.check(fromUrl, true);
        if (document.documentElement.classList.contains('lyn-gated')) setTimeout(() => this.input.focus(), 50);
      }

      async hash(value) {
        const data = new TextEncoder().encode(value.trim().toUpperCase());
        const buf = await crypto.subtle.digest('SHA-256', data);
        return [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, '0')).join('');
      }

      async check(value, silent = false) {
        if (!value || !value.trim()) return;
        const hash = await this.hash(value);
        if (this.dataset.hashes.split(',').includes(hash)) {
          try { localStorage.setItem('lynJvipCode', hash); } catch (e) {}
          document.documentElement.classList.remove('lyn-gated');
          window.dispatchEvent(new CustomEvent('lyn:jvip-unlocked'));
          return;
        }
        if (silent) return;
        this.input.setAttribute('aria-invalid', 'true');
        this.error.hidden = false;
        this.input.select();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyn-vip-optin"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Bily (Lead / Contact, redistribués par Bily vers Meta, Google Ads et Klaviyo) : SDK chargé dès l'affichage de la page,
    // seulement avec le consentement marketing. Les événements attendent dans l'onglet pour survivre aux redirections.
    const BILY_PENDING = 'lynBilyPending';
    const readJson = (store, key, fallback) => { try { return JSON.parse(store.getItem(key)) || fallback; } catch (e) { return fallback; } };
    const writeJson = (store, key, value) => { try { store.setItem(key, JSON.stringify(value)); } catch (e) {} };
    const marketingAllowed = () => { try { return !!window.Shopify?.customerPrivacy?.marketingAllowed?.(); } catch (e) { return false; } };
    const newId = () => (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
    const parts = (ms) => {
      const t = Math.max(0, Math.floor(ms / 1000));
      return { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
    };

    if (!customElements.get('lyn-countdown')) {
      customElements.define('lyn-countdown', class extends HTMLElement {
        connectedCallback() {
          this.target = Date.parse(this.dataset.target);
          if (Number.isNaN(this.target)) return;
          this.nums = Object.fromEntries([...this.querySelectorAll('[data-unit]')].map((el) => [el.dataset.unit, el]));
          this.tick();
          this.timer = setInterval(() => this.tick(), 1000);
        }
        disconnectedCallback() { clearInterval(this.timer); }
        tick() {
          const left = this.target - Date.now();
          if (left <= 0) {
            clearInterval(this.timer);
            this.classList.add('is-open');
            this.querySelector('.lyn-vip__open')?.removeAttribute('hidden');
          }
          const p = parts(left);
          for (const k of Object.keys(this.nums)) this.nums[k].textContent = pad(p[k]);
        }
      });
    }

    if (!customElements.get('lyn-vip-form')) {
      customElements.define('lyn-vip-form', class extends HTMLElement {
        connectedCallback() {
          this.emailForm = this.querySelector('[data-step="email"]');
          this.phoneForm = this.querySelector('[data-step="phone"]');
          this.done = this.querySelector('[data-step="done"]');
          this.email = '';
          this.emailForm.addEventListener('submit', (e) => this.onEmail(e));
          this.phoneForm.addEventListener('submit', (e) => this.onPhone(e));
          this.phoneForm.querySelector('[data-skip]').addEventListener('click', () => {
            if (this.dataset.thanksMode === 'true') this.goStep({ etape: 'agenda', sms: 'no' });
            else this.finish();
          });
          // Téléphone dans la 1re étape : la case SMS apparaît dès qu'un numéro est saisi.
          const firstPhone = this.emailForm.querySelector('input[name="phone"]');
          const firstConsent = this.emailForm.querySelector('[data-consent-first]');
          if (firstPhone && firstConsent) {
            firstPhone.addEventListener('input', () => (firstConsent.hidden = firstPhone.value.trim() === ''));
          }
          this.buildCalendar();
          this.exchangeId();
          if (this.dataset.thanksMode === 'true') this.startThanks();
          else {
            try {
              if (localStorage.getItem('lynVipDone') === this.dataset.target) this.show(this.done, false);
            } catch (e) {}
          }
          this.setupSticky();
          this.bilyFlush();
          document.addEventListener('visitorConsentCollected', () => this.bilyFlush());
        }

        companyId() {
          if (this.dataset.companyId) return this.dataset.companyId;
          const s = [...document.scripts].map((x) => x.src).find((src) => /klaviyo\.com\/onsite\/js\//.test(src));
          if (!s) return '';
          const q = s.match(/company_id=([A-Za-z0-9]+)/);
          if (q) return q[1];
          const p = s.match(/onsite\/js\/([A-Za-z0-9]{6})\//);
          return p ? p[1] : '';
        }

        // Identifiant Klaviyo (_kx) ajouté par Klaviyo aux liens de ses emails : lu dans l'adresse à l'arrivée,
        // gardé dans l'onglet car l'adresse change après l'étape SMS.
        exchangeId() {
          const valid = (value) => typeof value === 'string' && /^[A-Za-z0-9._=-]{1,300}$/.test(value);
          const fromUrl = new URLSearchParams(window.location.search).get('_kx');
          if (valid(fromUrl)) {
            try { sessionStorage.setItem('lynVipKx', fromUrl); } catch (e) {}
            return fromUrl;
          }
          let stored = null;
          try { stored = sessionStorage.getItem('lynVipKx'); } catch (e) {}
          return valid(stored) ? stored : '';
        }

        async klaviyo(profileAttributes) {
          const companyId = this.companyId();
          const listId = this.dataset.listId;
          if (!companyId || !listId) return false;
          const body = {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: this.dataset.source || 'LP VIP',
                // Propriété personnalisée posée sur le profil à chaque inscription (booléen, pour les segments « vp_vip est vrai »).
                profile: { data: { type: 'profile', attributes: { ...profileAttributes, properties: { vp_vip: true } } } },
              },
              relationships: { list: { data: { type: 'list', id: listId } } },
            },
          };
          const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(companyId)}`, {
            method: 'POST',
            // revision 2025-01-15 minimum : les versions antérieures refusent le champ « subscriptions » (consentements email / SMS).
            headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2025-07-15' },
            body: JSON.stringify(body),
          });
          if (!res.ok) throw new Error('klaviyo ' + res.status);
          return true;
        }

        async shopifyFallback(email) {
          // Sans liste Klaviyo configurée : inscription newsletter Shopify (synchronisée ensuite par Klaviyo).
          const fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '✓');
          fd.append('contact[email]', email);
          fd.append('contact[tags]', this.dataset.tags || 'newsletter');
          const res = await fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' });
          if (!res.ok) throw new Error('shopify ' + res.status);
        }

        setLoading(form, on) {
          form.classList.toggle('is-loading', on);
          form.querySelectorAll('button, input').forEach((el) => (el.disabled = on));
        }

        error(form, msg) {
          const el = form.querySelector('.lyn-vip__error');
          el.textContent = msg || '';
          el.hidden = !msg;
        }

        show(step, focus = true) {
          [this.emailForm, this.phoneForm, this.done].forEach((el) => (el.hidden = el !== step));
          if (focus) (step.querySelector('input') || step).focus({ preventScroll: true });
          const sticky = document.querySelector('[data-vip-sticky]');
          if (step === this.done && sticky) sticky.hidden = true;
        }

        async onEmail(e) {
          e.preventDefault();
          const input = this.emailForm.querySelector('input[name="email"]');
          const email = input.value.trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            input.setAttribute('aria-invalid', 'true');
            this.error(this.emailForm, 'Entrez une adresse email valide.');
            input.focus();
            return;
          }
          input.removeAttribute('aria-invalid');

          // Numéro facultatif saisi dès la 1re étape.
          const phoneInput = this.emailForm.querySelector('input[name="phone"]');
          const consentInput = this.emailForm.querySelector('input[name="sms_consent"]');
          let phone = '';
          if (phoneInput && phoneInput.value.trim() !== '') {
            const check = this.checkPhone(phoneInput.value);
            phone = check.phone || '';
            if (!phone) {
              phoneInput.setAttribute('aria-invalid', 'true');
              this.error(this.emailForm, this.phoneError(check, true));
              phoneInput.focus();
              return;
            }
            phoneInput.removeAttribute('aria-invalid');
            if (!consentInput.checked) {
              this.error(this.emailForm, 'Cochez la case pour recevoir l’alerte par SMS, ou laissez le numéro vide.');
              consentInput.focus();
              return;
            }
          }

          this.error(this.emailForm, '');
          this.setLoading(this.emailForm, true);
          try {
            const emailOnly = { email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
            let viaKlaviyo = false;
            let phoneRefused = false;
            if (phone) {
              try {
                viaKlaviyo = await this.klaviyo({
                  email,
                  phone_number: phone,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } }, sms: { marketing: { consent: 'SUBSCRIBED' } } },
                });
              } catch (err) {
                // Numéro refusé (ex. déjà rattaché à un autre profil) : on garde au moins l'inscription email.
                phoneRefused = true;
                viaKlaviyo = await this.klaviyo(emailOnly);
              }
            } else {
              viaKlaviyo = await this.klaviyo(emailOnly);
            }
            if (!viaKlaviyo) await this.shopifyFallback(email);
            this.email = email;
            const smsOk = viaKlaviyo && phone && !phoneRefused;
            this.signupId = newId();
            const client = { email: email.toLowerCase() };
            if (smsOk) client.phone = phone;
            this.bilyAdd('Lead', this.signupId, { bily_business_event: 'VIP Sign Up Submitted', bily_optimization_role: 'primary' }, client);
            if (smsOk) this.bilyAdd('Contact', this.signupId, { bily_business_event: 'SMS Alert Opt-in', bily_optimization_role: 'secondary' }, client);
            if (this.dataset.thanksUrl) {
              this.phone = smsOk ? phone : '';
              this.goThanks(email, !!smsOk, !!(viaKlaviyo && phoneRefused));
              return;
            }
            this.bilyFlush();
            window.dispatchEvent(new CustomEvent('lyn:vip-signup', { detail: { step: phone && !phoneRefused ? 'email+phone' : 'email' } }));
            if (viaKlaviyo && phoneRefused) {
              // Email enregistré, numéro refusé : on repropose l'étape SMS avec un message.
              this.show(this.phoneForm);
              this.error(this.phoneForm, 'Votre email est bien enregistré, mais ce numéro n’a pas pu l’être. Essayez un autre numéro ou passez cette étape.');
            } else if (viaKlaviyo && !phone) this.show(this.phoneForm);
            // Numéro enregistré, ou pas de liste Klaviyo (seul Klaviyo enregistre le numéro) : confirmation directe.
            else this.finish();
          } catch (err) {
            this.error(this.emailForm, 'Oups, l’inscription n’a pas fonctionné. Réessayez dans un instant.');
          } finally {
            if (!this.redirecting) this.setLoading(this.emailForm, false);
          }
        }

        // Accepte le numéro tel que la personne le tape et le remet au format international (+33…).
        // Renvoie { phone } ou { error: 'invalid' | 'landline' }.
        checkPhone(raw) {
          let p = String(raw || '').replace(/\(\s*0\s*\)/g, ''); // « +33 (0)6… » : le 0 entre parenthèses ne se compose pas
          p = p.replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');
          if (p.startsWith('00')) p = '+' + p.slice(2);
          if (!p.startsWith('+')) {
            if (/^0\d{9}$/.test(p)) p = '+33' + p.slice(1); // 06 12 34 56 78 : France par défaut
            else if (/^[67]\d{8}$/.test(p)) p = '+33' + p; // 6 12 34 56 78 : mobile français sans le 0
            else if (/^(33|32|41)\d{8,10}$/.test(p) || /^352\d{6,10}$/.test(p)) p = '+' + p; // indicatif sans le +
          }
          // Indicatif suivi du 0 national (« +33 06… », « +41 079… ») : on retire le 0.
          p = p.replace(/^\+(33|32|41|31|43|44|49)0/, '+$1');
          if (!/^\+[1-9]\d{7,14}$/.test(p)) return { error: 'invalid' };
          // Pays où l'on distingue mobile et fixe : [format valide, format mobile].
          const countries = [
            ['+33', /^\+33[1-9]\d{8}$/, /^\+33[67]\d{8}$/], // France
            ['+32', /^\+32\d{8,9}$/, /^\+324[5-9]\d{7}$/], // Belgique
            ['+41', /^\+41\d{9}$/, /^\+417[5-9]\d{7}$/], // Suisse
            ['+352', /^\+352\d{6,11}$/, /^\+3526\d{8}$/], // Luxembourg
          ];
          const c = countries.find(([code]) => p.startsWith(code));
          if (c) {
            if (!c[1].test(p)) return { error: 'invalid' };
            if (!c[2].test(p)) return { error: 'landline' };
          }
          return { phone: p };
        }

        normalizePhone(raw) {
          return this.checkPhone(raw).phone || '';
        }

        phoneError(check, optional) {
          if (check.error === 'landline') {
            return 'Pas possible de s’inscrire avec un numéro fixe : indiquez plutôt un numéro de portable' + (optional ? ', ou laissez le champ vide.' : '.');
          }
          return 'Entrez un numéro valide, par exemple 06 12 34 56 78' + (optional ? ', ou laissez le champ vide.' : '.');
        }

        async onPhone(e) {
          e.preventDefault();
          const input = this.phoneForm.querySelector('input[name="phone"]');
          const consent = this.phoneForm.querySelector('input[name="sms_consent"]');
          const check = this.checkPhone(input.value);
          const phone = check.phone || '';
          if (!phone) {
            input.setAttribute('aria-invalid', 'true');
            this.error(this.phoneForm, this.phoneError(check, false));
            input.focus();
            return;
          }
          if (!consent.checked) {
            this.error(this.phoneForm, 'Cochez la case pour recevoir l’alerte par SMS.');
            consent.focus();
            return;
          }
          input.removeAttribute('aria-invalid');
          this.error(this.phoneForm, '');
          this.setLoading(this.phoneForm, true);
          try {
            const profile = { phone_number: phone, subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
            if (this.email) profile.email = this.email;
            // Sans email connu (arrivée depuis un email Klaviyo), le _kx du lien rattache le numéro au profil de la cliente.
            // Si Klaviyo le refuse, le numéro est enregistré seul, comme avant.
            const kx = this.email ? '' : this.exchangeId();
            if (kx) {
              try {
                await this.klaviyo({ ...profile, _kx: kx });
              } catch (err) {
                await this.klaviyo(profile);
              }
            } else {
              await this.klaviyo(profile);
            }
            const contactClient = { phone };
            if (this.email) contactClient.email = this.email.toLowerCase();
            this.bilyAdd('Contact', this.signupId || newId(), { bily_business_event: 'SMS Alert Opt-in', bily_optimization_role: 'secondary' }, contactClient);
            window.dispatchEvent(new CustomEvent('lyn:vip-signup', { detail: { step: 'phone' } }));
            if (this.dataset.thanksMode === 'true') {
              try {
                const note = JSON.parse(sessionStorage.getItem('lynVipSignup') || '{}') || {};
                sessionStorage.setItem('lynVipSignup', JSON.stringify({ ...note, phone }));
              } catch (e) {}
              this.goStep({ etape: 'agenda', sms: 'ok' });
            }
            else {
              this.bilyFlush();
              this.finish();
            }
          } catch (err) {
            this.error(this.phoneForm, 'Ce numéro n’a pas pu être enregistré. Vérifiez-le ou passez cette étape.');
          } finally {
            if (!this.redirecting) this.setLoading(this.phoneForm, false);
          }
        }

        // Le suivi se fait par l'adresse de la page merci : etape= pilote l'affichage, email=ok / sms=ok|no marquent le parcours.
        // Paramètres distincts, jamais répétés. Sur la page merci, on repart de l'adresse nue : email=ok n'apparaît qu'à la première arrivée.
        goStep(params) {
          const base = this.dataset.thanksMode === 'true' ? window.location.pathname : this.dataset.thanksUrl;
          const url = new URL(base, window.location.origin);
          // Garde ?view= : sans lui, l'aperçu d'un template alternatif retomberait sur le template de la page.
          const view = new URLSearchParams(window.location.search).get('view');
          if (this.dataset.thanksMode === 'true' && view) url.searchParams.set('view', view);
          for (const [key, value] of Object.entries(params)) url.searchParams.set(key, value);
          this.redirecting = true;
          window.location.href = url.toString();
        }

        bilySentKey() {
          return 'lynBilySent:' + (this.dataset.target || '');
        }

        // Met un événement en attente : une seule fois par visiteur et par nom (Lead, Contact).
        bilyAdd(name, signupId, props, client) {
          const sent = readJson(localStorage, this.bilySentKey(), []);
          const pending = readJson(sessionStorage, BILY_PENDING, []);
          if (sent.includes(name) || pending.some((event) => event.name === name)) return;
          pending.push({
            name,
            payload: {
              bily_standard_event: name,
              bily_funnel_stage: 'lead',
              bily_business_model: 'ecommerce',
              ...props,
              // Identifiant stable par inscription : Meta fusionne les envois navigateur et serveur de Bily (nom + event_id).
              event_id: (name === 'Lead' ? 'vip-lead-' : 'vip-sms-') + signupId,
              client,
            },
          });
          writeJson(sessionStorage, BILY_PENDING, pending);
        }

        // Charge le SDK (une fois) et envoie les événements en attente, sur une page qui reste affichée (pas juste avant une redirection).
        bilyFlush() {
          if (this.bilyBusy || !this.dataset.bilySdk) return;
          // L'outil de consentement Shopify se charge après ce script : on l'attend avant de décider.
          if (!window.Shopify?.customerPrivacy) {
            if (this.bilyWaiting) return;
            this.bilyWaiting = true;
            const retry = () => {
              this.bilyWaiting = false;
              if (window.Shopify?.customerPrivacy) this.bilyFlush();
            };
            try {
              window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], retry);
            } catch (e) {
              setTimeout(retry, 4000);
            }
            return;
          }
          if (!marketingAllowed()) return;
          this.bilyBusy = true;
          this.bilySdk = this.bilySdk || import(this.dataset.bilySdk).then((sdk) => {
            sdk.init({ scriptUrl: this.dataset.bilyScript });
            return sdk;
          });
          this.bilySdk
            .then((sdk) => {
              if (!readJson(sessionStorage, BILY_PENDING, []).length) return;
              const sent = readJson(localStorage, this.bilySentKey(), []);
              for (const event of readJson(sessionStorage, BILY_PENDING, [])) {
                if (sent.includes(event.name)) continue;
                try {
                  sdk.track(event.name, event.payload);
                  sent.push(event.name);
                } catch (e) {}
              }
              writeJson(localStorage, this.bilySentKey(), sent);
              try { sessionStorage.removeItem(BILY_PENDING); } catch (e) {}
            })
            .catch(() => { this.bilySdk = null; })
            .finally(() => { this.bilyBusy = false; });
        }

        // L'email reste dans l'onglet (sessionStorage), jamais dans l'adresse.
        goThanks(email, sms, phoneRefused) {
          try { sessionStorage.setItem('lynVipSignup', JSON.stringify({ email, phoneRefused, signupId: this.signupId, phone: this.phone || '' })); } catch (e) {}
          this.goStep(sms ? { etape: 'agenda', email: 'ok', sms: 'ok' } : { etape: 'sms', email: 'ok' });
        }

        // Page merci : jamais le formulaire email, seulement l'étape SMS ou la confirmation.
        startThanks() {
          let note = {};
          try { note = JSON.parse(sessionStorage.getItem('lynVipSignup') || '{}') || {}; } catch (e) {}
          this.email = note.email || '';
          this.signupId = note.signupId || '';
          const agenda = new URLSearchParams(window.location.search).get('etape') === 'agenda';
          this.show(agenda ? this.done : this.phoneForm, false);
          if (!agenda && note.phoneRefused) {
            this.error(this.phoneForm, 'Votre email est bien enregistré, mais ce numéro n’a pas pu l’être. Essayez un autre numéro ou passez cette étape.');
          }
          if (agenda) {
            try { localStorage.setItem('lynVipDone', this.dataset.target); } catch (e) {}
          }
        }

        finish() {
          try { localStorage.setItem('lynVipDone', this.dataset.target); } catch (e) {}
          if (this.dataset.redirect) {
            window.location.href = this.dataset.redirect;
            return;
          }
          this.show(this.done);
        }

        buildCalendar() {
          const start = new Date(this.dataset.target);
          if (Number.isNaN(start.getTime())) return;
          const minutes = Number(this.dataset.eventDuration) || 60;
          const end = new Date(start.getTime() + minutes * 60000);
          const fmt = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
          const title = this.dataset.eventTitle || 'Ventes privées Lynae';
          const lines = ['Votre accès VIP aux ventes privées Lynae est ouvert.'];
          if (this.dataset.vipUrl) lines.push('Accès : ' + this.dataset.vipUrl);
          if (this.dataset.accessCode) lines.push('Code VIP : ' + this.dataset.accessCode);
          const details = (this.dataset.eventDetails || '').trim() || lines.join('\n');
          // Rappels (Apple / Outlook uniquement : le lien Google Agenda ne permet pas d'imposer des rappels).
          // La veille à 18h (heure de Paris), puis à l'heure de début.
          const paris = Object.fromEntries(
            new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
              .formatToParts(start).map((p) => [p.type, p.value])
          );
          const startH = Number(paris.hour);
          const startM = Number(paris.minute);
          const eveMinutes = (24 - 18) * 60 + startH * 60 + startM;
          const startLabel = startH + 'h' + (startM ? String(startM).padStart(2, '0') : '');

          const g = new URL('https://calendar.google.com/calendar/render');
          g.searchParams.set('action', 'TEMPLATE');
          g.searchParams.set('text', title);
          g.searchParams.set('dates', `${fmt(start)}/${fmt(end)}`);
          g.searchParams.set('details', details);
          if (this.dataset.vipUrl) g.searchParams.set('location', this.dataset.vipUrl);
          this.querySelector('[data-cal-google]').href = g.toString();

          const esc = (t) => t.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
          // Lignes .ics limitées à 75 octets (RFC 5545) : le long texte de l'événement est replié.
          const enc = new TextEncoder();
          const fold = (line) => {
            const out = [];
            let cur = '';
            let bytes = 0;
            for (const ch of line) {
              const n = enc.encode(ch).length;
              if (bytes + n > (out.length ? 74 : 75)) { out.push(cur); cur = ''; bytes = 0; }
              cur += ch;
              bytes += n;
            }
            out.push(cur);
            return out.join('\r\n ');
          };
          const ics = [
            'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Lynae//Ventes privees//FR', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH',
            'BEGIN:VEVENT',
            `UID:lynae-vip-${fmt(start)}@lynae.co`,
            `DTSTAMP:${fmt(new Date())}`,
            `DTSTART:${fmt(start)}`,
            `DTEND:${fmt(end)}`,
            `SUMMARY:${esc(title)}`,
            `DESCRIPTION:${esc(details)}`,
            this.dataset.vipUrl ? `LOCATION:${esc(this.dataset.vipUrl)}` : '',
            this.dataset.vipUrl ? `URL:${this.dataset.vipUrl}` : '',
            'BEGIN:VALARM', 'ACTION:DISPLAY', `DESCRIPTION:${esc('Demain à ' + startLabel + ' : ' + title)}`, `TRIGGER:-PT${eveMinutes}M`, 'END:VALARM',
            'BEGIN:VALARM', 'ACTION:DISPLAY', `DESCRIPTION:${esc(title)}`, 'TRIGGER:PT0M', 'END:VALARM',
            'END:VEVENT', 'END:VCALENDAR',
          ].filter(Boolean).map(fold).join('\r\n');
          this.querySelector('[data-cal-ics]').href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
        }

        setupSticky() {
          const sticky = document.querySelector('[data-vip-sticky]');
          if (!sticky) return;
          const timerEl = sticky.querySelector('[data-sticky-timer]');
          const target = Date.parse(this.dataset.target);
          const update = () => {
            const left = target - Date.now();
            if (!timerEl || Number.isNaN(target)) return;
            if (left <= 0) { timerEl.textContent = ''; return; }
            const p = parts(left);
            timerEl.textContent = `${p.d}j ${pad(p.h)}:${pad(p.m)}:${pad(p.s)}`;
          };
          update();
          setInterval(update, 1000);
          const io = new IntersectionObserver(([entry]) => {
            sticky.hidden = entry.isIntersecting || !this.done.hidden;
          });
          io.observe(this);
          sticky.querySelector('[data-vip-jump]').addEventListener('click', (e) => {
            e.preventDefault();
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => this.querySelector('form:not([hidden]) input')?.focus({ preventScroll: true }), 500);
          });
        }
      });
    }

    // Tout lien vers #vip-form (autres sections) ramène au formulaire.
    document.addEventListener('click', (e) => {
      const a = e.target.closest('a[href="#vip-form"]');
      if (!a || a.hasAttribute('data-vip-jump')) return;
      const form = document.getElementById('vip-form');
      if (!form) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => form.querySelector('form:not([hidden]) input')?.focus({ preventScroll: true }), 500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyn-vp-soon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lyn-vp-soon')) {
    customElements.define('lyn-vp-soon', class extends HTMLElement {
      connectedCallback() {
        this.start = Date.parse(this.dataset.start);
        this.parts = ['d', 'h', 'm', 's'].map((k) => this.querySelector(`[data-${k}]`));
        this.querySelector('[data-reload]')?.addEventListener('click', () => location.reload());
        if (Number.isNaN(this.start)) return;
        this.tick();
        this.t = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() { clearInterval(this.t); }

      tick() {
        const left = Math.max(0, Math.floor((this.start - Date.now()) / 1000));
        const pad = (n) => String(n).padStart(2, '0');
        const values = [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60];
        values.forEach((v, i) => { if (this.parts[i]) this.parts[i].textContent = pad(v); });
        if (left > 0) return;
        // Heure d'ouverture atteinte : la page passe sur le template de vente une fois le produit basculé.
        clearInterval(this.t);
        this.querySelector('.lyn-vps__waiting').hidden = true;
        this.querySelector('.lyn-vps__open').hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyn-vp-topbar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lyn-vp-topbar')) {
    customElements.define('lyn-vp-topbar', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.nums = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.nums[el.dataset.unit] = el));
        if (Number.isNaN(this.end)) return;
        this.tick();
        this.t = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.t); }
      tick() {
        const left = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
        const pad = (n) => String(n).padStart(2, '0');
        const values = { d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
        for (const unit in values) if (this.nums[unit]) this.nums[unit].textContent = pad(values[unit]);
        if (left === 0) {
          // Fin de l'accès VIP : on revient au bandeau classique.
          clearInterval(this.t);
          const after = this.querySelector('.lyn-vp-topbar__after');
          this.querySelector('.lyn-vp-topbar__live').hidden = true;
          if (after) after.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
